import Translator from 'src/requests/apa/Translator';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import { fetchLoginDynamic } from '../../reducers/user';


class LoginCMLogic {
    constructor(props) {
        this.props = props;
    }

    async loginFLow(loginParams, loginFunction) {        
        const response = await this.performLogin(loginParams, loginFunction);
        if (response && response.success) {
            await this.successLogin(response);
        } else {
            let message;
            if(response.error && response.error.code){
                switch (response.error.code) {
                    case 'CMS_014':
                        message = Translator.get('CMS_014','Usuario con correo electrónico o contraseña inválidos.');
                        return {message, code: response.error.code};
                    case 'CMS_050':
                        message = Translator.get('CMS_050','Número no registrado en operadora Telcel.');
                        return {message, code: response.error.code};
                    case 'CMS_051':
                        message = Translator.get('CMS_051','Has ingresado un código de verificación incorrecto.');
                        return {message, code: response.error.code};
                    case 'CMS_052':
                        message = Translator.get('CMS_052','Has excedido el número de intentos para ingresar a la aplicación. Por favor intenta nuevamente más tarde.');
                        return {message, code: response.error.code};
                    default:
                        message = Translator.get(response.error.code, null);
                        message = message || response.error.message || "Ha ocurrido un error desconocido"
                        return {message, code: response.error.code};
                    }
            } else {
                return {message: "Ha ocurrido un error desconocido"};
            }
        }
    }


    async successLogin(response) {
        DeviceStorage.setItem('userCM', JSON.stringify(response.response));
        fetchLoginDynamic(null);
     }

   

    async performLogin(loginParams, loginFunction) {
        let response = { success: false };
        try {
            response = await loginFunction(loginParams);
        } catch (error) {
            response.error = error;
        }
        return response;
    }
}

export default LoginCMLogic;



// WEBPACK FOOTER //
// ./src/authentication/LoginCM/LoginCMLogic.js